import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'changePasswordSuccess.title',
    defaultMessage: 'Password changed',
  },
  description: {
    id: 'changePasswordSuccess.description',
    defaultMessage: 'Your password has been successfully changed.',
  },
  buttonLabel: {
    id: 'changePasswordSuccess.buttonLabel',
    defaultMessage: 'My account',
  },
});
